export default {
 
  loadEmployees({commit}){
    return axios.get('/api/users/index')
          .then(response=>commit('setEmployees',response.data.data))
          .catch(error=>this.showErrorMessage(error))
  },
}
